const account_center = {
    not_enabled: 'O centro de contas não está ativado.',
    field_not_editable: 'O campo não é editável.',
    field_not_enabled: 'O campo não está habilitado.',
};
export default Object.freeze(account_center);
